import { withStyles, WithStyles } from '@material-ui/core/styles'
import React from 'react'
import styles from './divider-jss'

/* Define a shared prop interface */
interface DividerProps extends WithStyles<typeof styles> {
  thin?: number
}

/* Gradient Divider */
const Gradient: React.FC<DividerProps> = ({ thin = 1, classes, ...rest }) => <hr className={classes.gradient} style={{ height: `${thin}` }} {...rest} />

export const GradientDivider = withStyles(styles)(Gradient)

/* Dash Divider */
const Dash: React.FC<DividerProps> = ({ thin = 1, classes, ...rest }) => <hr className={classes.colorDash} style={{ height: `${thin}` }} {...rest} />

export const DashDivider = withStyles(styles)(Dash)

/* Shadow Divider */
const Shadow: React.FC<DividerProps> = ({ thin = 1, classes, ...rest }) => <hr className={classes.shadow} style={{ height: `${thin}` }} {...rest} />

export const ShadowDivider = withStyles(styles)(Shadow)

/* Shadow Inset */
const Inset: React.FC<DividerProps> = ({ thin = 1, classes, ...rest }) => <hr className={classes.inset} style={{ height: `${thin}` }} {...rest} />

export const InsetDivider = withStyles(styles)(Inset)

/* Flaired Edges Divider */
const FlairedEdges: React.FC<DividerProps> = ({ thin = 1, classes, ...rest }) => <hr className={classes.flairedEdges} style={{ height: `${thin}` }} {...rest} />

export const FlairedEdgesDivider = withStyles(styles)(FlairedEdges)

/* Content Divider */
interface ContentDividerProps extends DividerProps {
  content: string
}

const Content: React.FC<ContentDividerProps> = ({ thin = 1, classes, content, ...rest }) => (
  <hr className={classes.content} style={{ height: `${thin}` }} data-content={content} {...rest} />
)

export const ContentDivider = withStyles(styles)(Content)
